import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsyncSelect from "react-select/lib/Async";
import { NotificationManager } from "react-notifications";
import { NumberField } from "../../../../../../../../Utils/renderField/fieldsHookForms";
import { RenderKilogramo } from "../../../../../../../../Utils/renderField/renderReadField";
import { useDebouncedAsyncSelect } from "../../../../../../../../Utils/Hooks/useDebounce";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../../utility/constants";
import { PalletsTable } from "./PalletsTable";
const eliminarIcon = require("assets/img/icons/borrar.png");

export const ListadoPallets = (props) => {
    const { pallets = [], fueAtendidoPorBodega } = props;

    if (fueAtendidoPorBodega) {
        const palletsAprobados = pallets.filter(
            (pallet) => pallet.recibido_bodega,
        );
        const palletsRechazados = pallets.filter(
            (pallet) => !pallet.recibido_bodega,
        );

        return (
            <React.Fragment>
                {palletsAprobados.length > 0 && (
                    <PalletsTable
                        pallets={palletsAprobados}
                        headerText="Pallets recibidos"
                    />
                )}
                {palletsRechazados.length > 0 && (
                    <PalletsTable
                        pallets={palletsRechazados}
                        headerText="Pallets rechazados"
                    />
                )}
            </React.Fragment>
        );
    }

    return (
        <PalletsTable
            pallets={pallets}
            fueAtendidoPorBodega={fueAtendidoPorBodega}
        />
    );
};
